import { Box, Typography, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';

const WidgetEmptyState = (props) => {
  const { emptyTitle, emptySubtitle } = props;
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        alignSelf: 'stretch',
        display: 'flex',
        width: '100%',
        minHeight: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minHeight: '100%',
          bgcolor: palette.background.default,
          borderRadius: '12px',
          px: { xs: 2, sm: 3 },
          py: 1.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="subtitle1" fontWeight={400} color="text.primary">
          {emptyTitle}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.75}>
          {emptySubtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default WidgetEmptyState;
